import { TRANSACTION_TYPES } from './constants';

export const FLEET_ONLY_TRANSACTION_TYPE = TRANSACTION_TYPES[1].id;

export const FLEET_ONLY_BRAND = {
  canvas: '#FFFFFF',
  surface: '#F4F8FB',
  surfaceStrong: '#E7F0F6',
  ink: '#102036',
  inkMuted: '#4C6279',
  primary: '#004A80',
  primarySoft: '#3682AE',
  border: 'rgba(16, 32, 54, 0.12)',
  glow: 'rgba(54, 130, 174, 0.18)'
};

export const isFleetOnlyModeEnabled = (appSettings) => (
  Boolean(appSettings?.disable_fuel_management && appSettings?.fleet_management)
);

export const isFuelManagementDisabled = (appSettings) => (
  Boolean(appSettings?.disable_fuel_management)
);
